@import "../../theme/utils";

:host {
  display: flex;

  flex-direction: row;

  height: 100%;
}

.menu {
  &__main {
    display: flex;

    flex-direction: column;
    flex-grow: 1;
  }

  &__apps {
    display: flex;

    flex: 0 0 60px;
    flex-direction: column;
    align-items: center;

    height: 100%;

    padding-top: calc(constant(safe-area-inset-top) + 8px);
    padding-top: calc(env(safe-area-inset-top) + 8px);
    padding-right: 0;
    padding-bottom: calc(constant(safe-area-inset-bottom) + 8px);
    padding-bottom: calc(env(safe-area-inset-bottom) + 8px);
    padding-left: 0;

    border-top: 1px solid rgba(102, 102, 102, 0.1);
    border-right: 1px solid rgba(102, 102, 102, 0.1);

    background-color: var(--ion-color-light);
    box-sizing: border-box;

    ion-icon {
      color: #9fa0a5;
    }
  }

  &__coreo-nav {
    @extend %safe-bottom;

    border-top: 1px solid rgba(102, 102, 102, 0.1);

    .build-version {
      margin-top: 0;
      margin-bottom: 8px;

      font-size: 0.7rem;
    }
  }

  &__header {
    display: flex;

    flex-direction: column;
    align-items: center;
    justify-content: center;

    height: auto;

    padding: 24px;
    padding-top: calc(constant(safe-area-inset-top) + 24px);
    padding-top: calc(env(safe-area-inset-top) + 24px);

    background-color: var(--ion-color-primary);
    color: var(--ion-color-primary-contrast);

    text-align: center;

    h2 {
      font-size: 18px;
    }

    p {
      margin: 0;

      font-size: 14 px;
    }

    ion-avatar {
      width: 52px;
      height: 52px;
    }

    ion-icon {
      width: 100%;
      height: 100%;
    }
  }

  &__current-app {
    display: flex;

    align-items: center;
    justify-content: flex-start;

    width: 100%;
    height: 48px;

    padding-left: 1rem;

    border-top: 1px solid rgba(102, 102, 102, 0.1);
    border-bottom: 1px solid rgba(102, 102, 102, 0.1);

    background-color: var(--ion-color-light);

    font-size: 0.875rem;
    font-weight: 700;

    line-height: 12px;

    coreo-app-icon {
      --width: 24px;
      --height: 24px;
      margin-right: 12px;
    }
  }

  &__app {
    position: relative;

    width: 55px;
    height: 55px;

    margin-bottom: 8px;

    border-radius: 4px;

    background-repeat: no-repeat;
    background-size: contain;

    font-size: 3rem;

    text-align: center;

    coreo-app-icon {
      --height: 55px;
      --max-height: 55px;
      --width: 55px;
      --padding: 3px;
      --border-width: 3px;
    }

    &.active {
      border-color: var(--coreo-color-primary);

      coreo-app-icon {
        --border-color: var(--coreo-color-primary);
      }
    }

    ion-badge {
      position: absolute;
      right: -2px;
      bottom: -8px;
    }
  }

  &__pages {
    display: flex;

    flex-direction: column;
    flex-grow: 1;
    overflow-y: scroll;

    ion-item {
      --inline-padding-end: 10px;
    }

    ion-label {
      font-size: 0.9rem;

      white-space: pre-wrap;
    }

    ion-menu-toggle.disabled-menu {
      pointer-events: none;
    }

    p {
      margin-top: auto;

      font-size: 0.7rem;

      text-align: center;
    }
  }
}
